export default "__VITE_ASSET__573dcfa6__"